/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import UIGrid from '../uigrid';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'; // Optional theme CSS

const StreamTable = (props) => {
  const { streamNum, streamjsonData, unit_set_dict, decimalVal, translateObject } = props;
  function getValue(item, num) {
    return Number.parseFloat(item).toFixed(num);
  }
  function getPercentage(item) {
    return `${Number.parseFloat(item).toFixed(0)}%`;
  }
  function getUnitValue(item) {
    if (item === 'Pressure') {
      return `${unit_set_dict.Pressure}` || 'atm';
    } if (item === 'Flow') {
      return `${unit_set_dict['Volume Flow']}` || 'gpm';
    } return '';
  }

  const excelData = [
    { Ions: 'Ion', mg: 'mg/l', mgs: 'Molal' },
    { Ions: 'Calcium (Ca)', mg: getValue(streamjsonData.ppm_dict['Ca++'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Ca++'], decimalVal) },
    { Ions: 'Magnesium (Mg)', mg: getValue(streamjsonData.ppm_dict['Mg++'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Mg++'], decimalVal) },
    { Ions: 'Sodium (Na)', mg: getValue(streamjsonData.ppm_dict['Na+'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Na+'], decimalVal) },
    { Ions: 'Potassium (K)', mg: getValue(streamjsonData.ppm_dict['K+'], decimalVal), mgs: getValue(streamjsonData.molal_dict['K+'], decimalVal) },
    { Ions: 'Ammonia - N (NH4)', mg: getValue(streamjsonData.ppm_dict['NH4+'], decimalVal), mgs: getValue(streamjsonData.molal_dict['NH4+'], decimalVal) },
    { Ions: 'Barium (Ba)', mg: getValue(streamjsonData.ppm_dict['Ba++'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Ba++'], decimalVal) },
    { Ions: 'Strontium (Sr)', mg: getValue(streamjsonData.ppm_dict['Sr++'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Sr++'], decimalVal) },
    { Ions: 'Iron (Fe)', mg: getValue(streamjsonData.ppm_dict['Fe++'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Fe++'], decimalVal) },
    { Ions: 'Manganese (Mn)', mg: getValue(streamjsonData.ppm_dict['Mn++'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Mn++'], decimalVal) },
    { Ions: 'Sulfate (SO4)', mg: getValue(streamjsonData.ppm_dict['SO4--'], decimalVal), mgs: getValue(streamjsonData.molal_dict['SO4--'], decimalVal) },
    { Ions: 'Chloride (Cl)', mg: getValue(streamjsonData.ppm_dict['Cl-'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Cl-'], decimalVal) },
    { Ions: 'Fluoride (F)', mg: getValue(streamjsonData.ppm_dict['F-'], decimalVal), mgs: getValue(streamjsonData.molal_dict['F-'], decimalVal) },
    { Ions: 'Nitrate (NO3)', mg: getValue(streamjsonData.ppm_dict['NO3-'], decimalVal), mgs: getValue(streamjsonData.molal_dict['NO3-'], decimalVal) },
    { Ions: 'Bromide (Br)', mg: getValue(streamjsonData.ppm_dict['Br-'], decimalVal), mgs: getValue(streamjsonData.molal_dict['Br-'], decimalVal) },
    { Ions: 'Phosphate (PO4)', mg: getValue(streamjsonData.ppm_dict['PO4---'], decimalVal), mgs: getValue(streamjsonData.molal_dict['PO4---'], decimalVal) },
    { Ions: 'Boron (B)', mg: getValue(streamjsonData.ppm_dict['B-'], decimalVal), mgs: getValue(streamjsonData.molal_dict['B(OH)3'], decimalVal) },
    { Ions: 'Silica (SiO2)', mg: getValue(streamjsonData.ppm_dict.SiO2, decimalVal), mgs: getValue(streamjsonData.molal_dict.H4SiO4, decimalVal) },
    { Ions: 'Hydrogen Sulfide (H2S)', mg: getValue(streamjsonData.ppm_dict.H2S, decimalVal), mgs: getValue(streamjsonData.molal_dict.H2S, decimalVal) },
    { Ions: 'Alkalinity', mg: getValue(streamjsonData.prop_dict.malk, 2), mgs: '' },
    { Ions: `Temperature, ${unit_set_dict.Temperature}`, mg: getValue(streamjsonData.prop_dict.temp, 2), mgs: '' },
    { Ions: 'pH', mg: getValue(streamjsonData.prop_dict.ph, 2), mgs: '' }
  ];

  const rowData = [
    { Ions: 'Calcium (Ca)', mg: getValue(streamjsonData.ppm_dict['Ca++'], decimalVal) },
    { Ions: 'Magnesium (Mg)', mg: getValue(streamjsonData.ppm_dict['Mg++'], decimalVal) },
    { Ions: 'Sodium (Na)', mg: getValue(streamjsonData.ppm_dict['Na+'], decimalVal) },
    { Ions: 'Potassium (K)', mg: getValue(streamjsonData.ppm_dict['K+'], decimalVal) },
    { Ions: 'Ammonia - N (NH4)', mg: getValue(streamjsonData.ppm_dict['NH4+'], decimalVal) },
    { Ions: 'Barium (Ba)', mg: getValue(streamjsonData.ppm_dict['Ba++'], decimalVal) },
    { Ions: 'Strontium (Sr)', mg: getValue(streamjsonData.ppm_dict['Sr++'], decimalVal) },
    { Ions: 'Iron (Fe)', mg: getValue(streamjsonData.ppm_dict['Fe++'], decimalVal) },
    { Ions: 'Manganese (Mn)', mg: getValue(streamjsonData.ppm_dict['Mn++'], decimalVal) },
    { Ions: 'Sulfate (SO4)', mg: getValue(streamjsonData.ppm_dict['SO4--'], decimalVal) },
    { Ions: 'Chloride (Cl)', mg: getValue(streamjsonData.ppm_dict['Cl-'], decimalVal) },
    { Ions: 'Fluoride (F)', mg: getValue(streamjsonData.ppm_dict['F-'], decimalVal) },
    { Ions: 'Nitrate (NO3)', mg: getValue(streamjsonData.ppm_dict['NO3-'], decimalVal) },
    { Ions: 'Bromide (Br)', mg: getValue(streamjsonData.ppm_dict['Br-'], decimalVal) },
    { Ions: 'Phosphate (PO4)', mg: getValue(streamjsonData.ppm_dict['PO4---'], decimalVal) },
    { Ions: 'Boron (B)', mg: getValue(streamjsonData.ppm_dict['B-'], decimalVal) },
    { Ions: 'Silica (SiO2)', mg: getValue(streamjsonData.ppm_dict.SiO2, decimalVal) },
    { Ions: 'Hydrogen Sulfide (H2S)', mg: getValue(streamjsonData.ppm_dict.H2S, decimalVal) },
    { Ions: 'Bicarbonate (HCO3)', mg: getValue(streamjsonData.ppm_dict['HCO3-'], decimalVal) },
    { Ions: 'Carbon Dioxide (CO2)', mg: getValue(streamjsonData.ppm_dict.CO2, decimalVal) },
    { Ions: 'Carbonate (CO3)', mg: getValue(streamjsonData.ppm_dict['CO3--'], decimalVal) }
  ];
  // Osmotic Presure and conductivity to stream properties table ----> Kranthi

  // Abhishek code for to add hardness
  // const caa = getValue(streamjsonData.ppm_dict['Ca++'], decimalVal);
  // const mgg = getValue(streamjsonData.ppm_dict['Mg++'], decimalVal);

  // const hadns = getValue(streamjsonData.hardness, 2);

  // let hardnesss = 0;
  // if (hadns === 0 && caa > 0 || mgg > 0) {
  //   hardnesss = getValue((caa * 2.51) + (mgg * 4.11), 2);
  // }
  // else{
  //   hardnesss = getValue(streamjsonData.hardness, 2);
  // }

  const rowData2 = [
    { Parameter: `${translateObject('Flow')}, ${getUnitValue('Flow')}`, Value: getValue(streamjsonData.prop_dict.flow, 2) },
    { Parameter: `${translateObject('Temperature')}, ${unit_set_dict.Temperature}`, Value: getValue(streamjsonData.prop_dict.temp, 2) },
    { Parameter: `${translateObject('Pressure')}, ${getUnitValue('Pressure')}`, Value: getValue(streamjsonData.prop_dict.press, 2) },
    { Parameter: 'TDS, mg/l', Value: getValue(streamjsonData.prop_dict.tds, 2) },
    { Parameter: 'pH', Value: getValue(streamjsonData.prop_dict.ph, 2) },
    { Parameter: 'Alkalinity, ppm CaCO3', Value: getValue(streamjsonData.prop_dict.malk, 2) },
    // { Parameter: 'Hardness, ppm as CaCO3 ', Value: hardnesss },
    { Parameter: 'Hardness, ppm as CaCO3 ', Value: getValue(streamjsonData.hardness, 2) },
    { Parameter: `${translateObject('Density')}, kg/m3`, Value: getValue(streamjsonData.sat_indices.density, 2) },
    { Parameter: 'Ionic Strength', Value: getValue(streamjsonData.ionic_strength, 2) },
    { Parameter: `${translateObject('Osmotic Pressure')}, ${getUnitValue('Pressure')}`, Value: getValue(streamjsonData.sat_indices.osmotic_pressure, 2) },
    { Parameter: `${translateObject('Conductivity')}, µS/cm `, Value: getValue(streamjsonData.sat_indices.conductivity, decimalVal === 3 ? decimalVal - 2 : decimalVal - 1) }
  ];

  const rowData3 = [
    { Parameter: 'BaSO4 Saturation', Value: getPercentage(streamjsonData.sat_indices.baso4) },
    { Parameter: 'CaF2 Saturation', Value: getPercentage(streamjsonData.sat_indices.caf2) },
    { Parameter: 'CaSO4 Saturation', Value: getPercentage(streamjsonData.sat_indices.caso4) },
    { Parameter: 'SiO2 Saturation', Value: getPercentage(streamjsonData.sat_indices.sio2) },
    { Parameter: 'Mg(OH)2 Saturation', Value: getPercentage(streamjsonData.sat_indices.mgoh2) },
    { Parameter: 'SrSO4 Saturation', Value: getPercentage(streamjsonData.sat_indices.srso4) },
    { Parameter: 'Struvite Saturation', Value: getPercentage(streamjsonData.sat_indices.struvite) },
    { Parameter: 'Langelier Index', Value: getValue(streamjsonData.sat_indices.lsi, 2) },
    { Parameter: 'Stiff-Davis Index', Value: getValue(streamjsonData.sat_indices.sdi, 2) },
  ];

  const [columnDefs] = useState([
    { tag: 'Ions', hdata: 'Ions', datatype: 'text', disabled: true },
    { tag: 'mg', hdata: 'mg/l', datatype: 'text', disabled: true }
  ]);
  const [columnDefs2] = useState([
    { tag: 'Parameter', hdata: `${translateObject('Parameter')}`, datatype: 'text', disabled: true },
    { tag: 'Value', hdata: `${translateObject('Value')}`, datatype: 'text', disabled: true }
  ]);

  const exelarry = [];
  exelarry.push([`Water Composition of Stream '${streamNum}'`, '', '']);
  excelData.map((f) => {
    exelarry.push([f.Ions, f.mg, f.mgs]);
  });
  return (
    <div className="App">
      <Grid container justifyContent="space-between" alignItems="stretch">
        <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
          <div className="ag-theme-alpine stream-ag-grid no_drag" style={{ height: '100%' }}>
            <div className="stream-modal" style={{ marginTop: '4%' }}>
              <div className="box-border M_Bold">{translateObject('Ion Composition')}</div>
              <UIGrid
                data={rowData}
                properties={columnDefs}
                tableClassName='ion_composition'
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
          <div className="ag-theme-alpine stream-ag-grid no_drag" style={{ height: '100%' }}>
            <div className="stream-modal" style={{ marginTop: '2.8%' }}>
              <div className="box-border M_Bold">{translateObject('Stream Properties')}</div>
              <UIGrid
                data={rowData2}
                properties={columnDefs2}
                tableClassName='stream_properties'
              />
            </div>
            <div className="stream-modal no_drag" style={{ marginTop: 17 }}>
              <div className="box-border M_Bold">{translateObject('Saturation Data')}</div>
              <UIGrid
                data={rowData3}
                properties={columnDefs2}
                tableClassName='saturation_data'
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default StreamTable;